
export const StatusColor = {
    approve: '#55BB22',
    pending: ' #FFBB44',
    waiting_approval: '#F90648',
    disapprove: '#0076FC',
    lead: '#666666',
	proposed_10: '#17d8b2',
	proposed_50: '#1E8449',
	proposed_90: '#138D75',
	lost: '#FC0000',
	'No define yet': '#8866bb',
	'undefined': '#8866bb',
	'-2': '#8866bb'
};

export const CurrencyCode ={
	MY: "MYR",
	CN: "CNY",
	SG: "SGD",
	PH: "PHP",
	VN: "VND",
	TH: "THB",
	ID: "IDR",
	HK: "HKD",
	US: "USD"
}
export const StatusValue={
	approve : "Approved",
	pending : "Pending",
	disapprove : "Not Approved",
	lead :"Lead",
	proposed_10:"Proposed - 10%",
	proposed_50:"Proposed - 50%",
	proposed_90:"Proposed - 90%",
	lost: "Lost",
	waiting_approval:"Waiting For Approval"
}

export const country ={
AU:"Australia",
VG:"British Virgin Islands",
CA:"Canada",
CN:"China",
CY:"Cyprus",
HK:"Hong Kong",
IN:"India",
ID: "Indonesia",
IL:"Israel",
JP:"Japan",
MY:"Malaysia",
MT:"Malta",
NL:"Netherlands",
NZ:"New Zealand",
PH :"Philippines",
SG:"Singapore",
KR :"South Korea",
CH :"Switzerland",
TW : "Taiwan",
TH : "Thailand",
AE : "United Arab Emirates",
GB : "United Kingdom",
US : "United States",
VN : "Vietnam"
}
export const vapidKey = 'BF180NMKQyTlFDQNFQjknxnCv01AH50kaOST7mAYw-KB1rN3kipSHP-FGM1H_9237UqxSWaaRGwuZVmBupcEMY4'
export const notificationsEnabled = false
export const fstCheck = true
export const notificationsSupported = false
export const buttonDisabled = false
export const subscription = null
